import React, { useEffect, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faXmark, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { api } from "../../Constant";

const CartTotal = ({
    cartUpdated = [],
    CartTotalText = "Proceed To Pay",
    selectedAddressId,
    shippingRate,
    showShipping = false,
    productTotal = 0,
    totalAmount = 0,
    deliveryAvailable = 1
}) => {
    const location = useLocation();
    const navigation = useNavigate();
    const [couponDetail, setCouponDetail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showCoupon, setShowCoupon] = useState(true);
    const [apiTotal, setApiTotal] = useState(null); // ✅ Add state for API total

    // ✅ User or Guest Identifier
    const getApiIdentifier = useCallback(() => {
        const userId = localStorage.getItem('userId');
        const guestId = localStorage.getItem('guest_id');

        if (guestId && userId === guestId) {
            return { guest_id: guestId };
        }

        if (userId) {
            return { user_id: userId };
        }

        return null;
    }, []);

    console.log("cartUpdated", cartUpdated);

    const cartItems = cartUpdated || [];
    const productTotalPrice = cartItems.reduce(
        (sum, item) => sum + Number(item.total || 0),
        0
    );

    const shippingCharge = Number(shippingRate || 0);
    const localFinalTotal = productTotalPrice + (showShipping ? shippingCharge : 0); // Renamed to localFinalTotal

    // ✅ Use API total if available, otherwise use local calculation
    const finalTotal = apiTotal !== null ? Number(apiTotal) : localFinalTotal;

    const handleContinue = async () => {
        if (location.pathname === "/shoping-cart") {
            navigation("/Billing-Address");
            return;
        }

        const identifier = getApiIdentifier();
        if (!identifier) {
            alert("Your session has expired. Please log in again.");
            return;
        }

        setIsLoading(true);
        try {
            // ✅ Use the actual finalTotal (which could be from API)
            const finalAmount = couponDetail ? finalTotal : localFinalTotal;

            const orderResponse = await axios.post(`${api}order_place`, {
                ...identifier,
                address_id: selectedAddressId,
                coupon_id: localStorage.getItem("coupon_id"),
                product_details: cartItems.map(item => ({
                    product_id: item.product_id,
                    quantity: item.selected_quantity,
                    product_amount: item.discount_price && item.discount_price > 0
                        ? item.discount_price
                        : item.price, // ✅ fallback to price if discount_price is 0
                    product_total: item.total,
                })),
                coupon_discount: couponDetail?.discounted_amount || 0,
                total: finalAmount,
            });

            if (!orderResponse.data.success) {
                throw new Error(orderResponse.data.message || "Failed to create order.");
            }

            const { order_id: serverOrderId, razorpay_order_id } = orderResponse.data;
            // console.log('gdfggd' + serverOrderId);

            const options = {
                key: "rzp_live_RSwLSAE4MVSJTz",
                // key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_vmxoAc8eMJjXS5",
                amount: Math.round(finalAmount * 100),
                currency: "INR",
                name: "Little Love Nature",
                description: `Order ID: ${serverOrderId}`,
                order_id: razorpay_order_id,
                handler: async function (paymentResponse) {
                    try {
                        const verificationResponse = await axios.post(`${api}order_place`, {
                            ...identifier,
                            payment_id: paymentResponse.razorpay_payment_id,
                            order_id: serverOrderId,
                            razorpay_order_id: paymentResponse.razorpay_order_id,
                            razorpay_signature: paymentResponse.razorpay_signature,
                        });

                        if (verificationResponse.data.success === "true") {
                            navigation("/Order-success", { state: { orderId: serverOrderId } });
                        } else {
                            alert(verificationResponse.data.message || "Payment successful, but order confirmation failed.");
                        }
                    } catch (error) {
                        alert(error.response?.data?.message || "A server error occurred during payment verification.");
                    }
                },
                prefill: {
                    name: localStorage.getItem("userName") || 'Guest User',
                    email: localStorage.getItem("userEmail") || undefined,
                    contact: localStorage.getItem("userPhone") || undefined,
                },
                theme: { color: "#227070" },
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();

        } catch (error) {
            console.error("Order process error:", error);
            alert(error.message || "An unexpected error occurred.");
        } finally {
            setIsLoading(false);
        }
    };

    const coupannav = () => {
        navigation("/Coupouns");
        localStorage.setItem("coupon_source", "cart");
        localStorage.setItem("totalamnt", localFinalTotal); // Use localFinalTotal here
    };

    const removeCoupon = () => {
        setCouponDetail(null);
        setApiTotal(null); // ✅ Reset API total when removing coupon
        setShowCoupon(true);
        localStorage.removeItem("coupon_id");
    };

    useEffect(() => {
        const couponId = localStorage.getItem("coupon_id");
        if (!localFinalTotal || !couponId) {
            setCouponDetail(null);
            setApiTotal(null); // ✅ Reset API total
            setShowCoupon(true);
            return;
        }

        axios.post(`${api}Coupon_discount_details`, {
            total_amount: localFinalTotal, // Use localFinalTotal for API call
            coupon_id: couponId
        })
            .then(response => {
                if (response.data.success === "true") {
                    setCouponDetail(response.data.coupons);
                    // ✅ Extract and set the total from API response
                    // Remove commas and convert to number
                    const apiTotalValue = parseFloat(response.data.coupons.total.replace(/,/g, ''));
                    setApiTotal(apiTotalValue);
                    setShowCoupon(false);
                } else {
                    removeCoupon();
                }
            })
            .catch(error => {
                console.error("Coupon fetch error:", error);
                removeCoupon();
            });
    }, [localFinalTotal, location.pathname]);


    const isButtonDisabled = isLoading || (location.pathname.includes("Billing-Address") && !selectedAddressId) || cartItems.length === 0;

    return (
        <div className="carttotal-bg">
            <div className="row">
                <div className="col-lg-12 title"><h2>CART TOTAL</h2></div>
            </div>
            <div className="row">
                <div className="col-lg-12 cart-total">
                    <div className="cart-itemcont cart-item-border">
                        <h6>Cart Items</h6>
                        <p>{cartItems.length}</p>
                    </div>

                    {cartItems.length === 0 ? (
                        <div className="no-items-in-cart"><p>No items in cart</p></div>
                    ) : (
                        cartItems.map((item) => (
                            <div key={item.product_id} className="cart-itemcont inner-b">
                                <h6>{item.name} ({item.selected_quantity})</h6>
                                <p>₹{item.total?.toFixed(2)}</p>
                            </div>
                        ))
                    )}


                    <div className="cart-itemcont inner-b">
                        <h6>Subtotal</h6>
                        <p>₹{productTotalPrice.toFixed(2)}</p>
                    </div>


                    <div
                        className="cart-itemcont double-border"
                        onClick={showCoupon ? coupannav : undefined}
                        style={{ cursor: showCoupon ? 'pointer' : 'default' }}
                    >
                        {showCoupon ? (
                            <>
                                <h6>Select Coupon</h6>
                                <p><FontAwesomeIcon icon={faAngleRight} /></p>
                            </>
                        ) : (
                            <>
                                <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
                                    <h6>{couponDetail?.coupon_code}</h6>
                                    <div className="cancel-btncoupn" onClick={removeCoupon}>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </div>
                                </div>
                                <p style={{ color: "#227070", fontWeight: "600" }}>
                                    -₹{Number(couponDetail?.discounted_amount ?? 0).toFixed(2)}
                                </p>
                            </>
                        )}
                    </div>


                    {showShipping && (
                        <div className="cart-itemcont inner-b mt-2">
                            <h6>Shipping Charge</h6>
                            <p>₹{shippingRate.toFixed(2)}</p>
                        </div>
                    )}



                    <div className="cart-itemcont inner-b total">
                        <h6>Grand Total</h6>
                        <p>₹{finalTotal.toFixed(2)}</p>
                    </div>



                    <div className="cart-itemcont inner-b tatalcontinue">
                        <button onClick={handleContinue} disabled={isButtonDisabled || !deliveryAvailable}>
                            {isLoading ? (
                                <>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Processing...
                                </>
                            ) : (
                                CartTotalText
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartTotal;
